var exports = {
  "k": "xdde3148b--45eca0--container",
};

module.exports = exports;
